import { useEffect } from 'react';
import { useReducer, useMemo } from "react";
import { createContext, useContext } from "react";

import { restApi } from './restApi';
import { config } from '../config/config';
import { ValidateError } from '../utils/customError';

const initUserData: UserObject = {
  id: "",

  name: "",
  email: "",
  userType: "",

  image: "",
  coverImage: "",
  location: "",
  bio: "",

  github: "",
  linkedin: "",
  twitter: "",

  balance: 0,
  totalEarning: 0,
  weeklyEarning: 0,
  totalStudents: 0,

  mailVerify: "UnVerified",
}

const INIT_STATE: InitStateObject = {
  loading: true,
  showRecruitment: true,

  lang: "jp",
  minimumAmount: 1,
  projectName: "",
  logoImage: 0,

  authToken: "",
  loginStatus: false,
  userData: initUserData,

  notification: {
    message: "",
    open: false,
    bg: "",
    textColor: "",
  }
}

// create context
const GlobalContext = createContext<any>({});
const reducer = (state: InitStateObject, data: Partial<InitStateObject>) => {
  if (typeof data.authToken === "string") setStore(data.authToken);
  return { ...state, ...data };
}

// use contexts
function useGlobalContext() {
  return useContext(GlobalContext);
}

// setAuthToken to localstorage Start
const getStore = async (): Promise<string> => {
  try {
    const appKey = config.FRONTEND_URL + '-config';
    const buf = window.localStorage.getItem(appKey + 'authToken');

    if (typeof buf === 'string' && !!buf) {
      return buf;
    } else {
      throw new Error("Type Error!");
    }
  } catch (err) {
    return '';
  }
}

const setStore = (authToken: string) => {
  const appKey = config.FRONTEND_URL + '-config';
  window.localStorage.setItem(appKey + 'authToken', authToken);
}
// setAuthToken to localstorage End

const Provider = ({ children }: any) => {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);

  useEffect(() => {
    initSessionSetting();
    getProjectInformation();
  }, [])

  useEffect(() => {
    restApi.setAuthToken(state.authToken);
  }, [state.authToken])

  const initSessionSetting = async () => {
    try {
      const authToken = await getStore();
      if (!!authToken) {
        const loginStatus = await restApi.loginStatus(authToken);
        if (!!loginStatus?.status) {
          const updateData = {
            loading: false,
            loginStatus: true,
            authToken: authToken,
            userData: loginStatus.userData,
          }

          dispatch(updateData);
        } else {
          throw new ValidateError("Invalid authToken!");
        }
      } else {
        throw new ValidateError("Invalid authToken!");
      }
    } catch (err: any) {
      dispatch({
        loading: false,
        loginStatus: false,
        authToken: "",
        userData: initUserData
      })
    }
  }

  const getProjectInformation = async () => {
    try {
      const resData = await restApi.getProjectInfor();
      if (!!resData) {
        dispatch({
          logoImage: resData.logoImage,
          projectName: resData.projectName,
          notification: {
            open: resData.notification,
            message: resData.notificationMessage,
            bg: resData.notificationBgColor,
            textColor: resData.notificationTextColor,
          }
        })
      }
    } catch (err: any) {
      console.log(err.message)
    }
  }

  return (
    <GlobalContext.Provider
      value={useMemo(() => [
        state, { dispatch }
      ], [state])}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export { useGlobalContext, Provider, initUserData };